<template>
  <div class="activity-time" :class="isStaging3 ? 'staging3' : ''">
    <VueLazyImg v-if="isLargeScreen === false" classStyle="img-mobile" :src="isStaging3
      ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/db2d5458-8914-4c7a-97ec-0127cc112c97.png'
      : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/bbd7449d-2370-4573-9820-8f74380a993b.png'" />
    <template v-else>
      <div style="max-width: 1360px;">
        <VueLazyImg classStyle="img-1"
          src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/6efd70bb-cb38-48b4-a419-5e609b7ca212.png" />
        <VueLazyImg v-if="!isStaging3" classStyle="img-2"
          src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/67381ae9-0d4c-402e-819a-6f49ac4dd4c0.png" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { PageUI } from "./common/api/request";
import Block from "./common/block.vue";
import useDevice from "./common/useDevice";

const props = withDefaults(
  defineProps<{
    list: PageUI["rewards"];
    isStaging3?: boolean;
  }>(),
  {
    list: () => [],
  },
);

// const { isLargeScreen } = useDevice();
const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})
</script>

<style scoped lang="less">
.activity-time {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 2.8rem;
  flex: 1;

  @media screen and (max-width: 1360px) {
    margin-bottom: 0.56rem;
  }

  &.staging3 {
    margin-bottom: 0;
    @media screen and (max-width: 1360px) {
      margin-bottom: 0;
    }
  }


  :deep(.img) {
    &-mobile {
      width: 100%;
      height: auto;

      @media screen and (max-width:1360px) and (min-width:700px) {
        max-width: 80vw;
      }
    }

    &-1 {
      width: 100%;
    }

    &-2 {
      width: 100%;
    }
  }
}
</style>
